import React from 'react';
// config-gen-import-statement
import { ReactComponent as GA } from '@svg/ga.svg';
import { ReactComponent as AM } from '@svg/am.svg';
import { ReactComponent as ACTIVE_CAMPAIGN } from '@svg/active_campaign.svg';
import { ReactComponent as APPCUES } from '@svg/appcues.svg';
import { ReactComponent as CLEVERTAP } from '@svg/clever_tap.svg';
import { ReactComponent as MP } from '@svg/mp.svg';
import { ReactComponent as FB } from '@svg/fb.svg';
import { ReactComponent as FACEBOOK_PIXEL } from '@svg/facebook_pixel.svg';
import { ReactComponent as ADJ } from '@svg/adj.svg';
import { ReactComponent as HS } from '@svg/hs.svg';
import { ReactComponent as S3 } from '@svg/s3.svg';
import { ReactComponent as GCS } from '@svg/gcs.svg';
import { ReactComponent as MINIO } from '@svg/minio.svg';
import { ReactComponent as RS } from '@svg/rs.svg';
import { ReactComponent as BQ } from '@svg/bq.svg';
import { ReactComponent as SNOWFLAKE } from '@svg/snowflake.svg';
import { ReactComponent as POSTGRES } from '@svg/postgres.svg';
import { ReactComponent as CLICKHOUSE } from '@svg/clickhouse.svg';
import { ReactComponent as AF } from '@svg/af.svg';
import { ReactComponent as MAILCHIMP } from '@svg/mailchimp.svg';
import { ReactComponent as HOTJAR } from '@svg/hotjar.svg';
import { ReactComponent as SALESFORCE } from '@svg/salesforce.svg';
import { ReactComponent as SEGMENT } from '@svg/segment.svg';
import { ReactComponent as AUTOPILOT } from '@svg/autopilot.svg';
import { ReactComponent as GOOGLEADS } from '@svg/googleads.svg';
import { ReactComponent as GOOGLESHEETS } from '@svg/googlesheets.svg';
import { ReactComponent as AZURE_BLOB } from '@svg/azure_blob.svg';
import { ReactComponent as VWO } from '@svg/vwo.svg';
import { ReactComponent as INTERCOM } from '@svg/intercom.svg';
import { ReactComponent as HEAP } from '@svg/heap.svg';
import { ReactComponent as BRANCH } from '@svg/branch.svg';
import { ReactComponent as KOCHAVA } from '@svg/kochava.svg';
import { ReactComponent as GTM } from '@svg/gtm.svg';
import { ReactComponent as BRAZE } from '@svg/braze.svg';
import { ReactComponent as KEEN } from '@svg/keen.svg';
import { ReactComponent as KISSMETRICS } from '@svg/kissmetrics.svg';
import { ReactComponent as KLAVIYO } from '@svg/klaviyo.svg';
import { ReactComponent as CUSTOMERIO } from '@svg/customerio.svg';
import { ReactComponent as CHARTBEAT } from '@svg/chartbeat.svg';
import { ReactComponent as FIREBASE } from '@svg/firebase.svg';
import { ReactComponent as GA4 } from '@svg/ga4.svg';
import { ReactComponent as LEANPLUM } from '@svg/leanplum.svg';
import { ReactComponent as FULLSTORY } from '@svg/fullstory.svg';
import { ReactComponent as WEBHOOK } from '@svg/webhook.svg';
import { ReactComponent as HUBSPOT } from '@svg/hs.svg';
import { ReactComponent as PERSONALIZE } from '@svg/personalize.svg';
import { ReactComponent as BUGSNAG } from '@svg/bugsnag.svg';
import { ReactComponent as LOTAME } from '@svg/lotame.svg';
import { ReactComponent as LOTAME_MOBILE } from '@svg/lotame_mobile.svg';
import { ReactComponent as SLACK } from '@svg/slack.svg';
import { ReactComponent as KINESIS } from '@svg/kinesis.svg';
import { ReactComponent as KUSTOMER } from '@svg/kinesis.svg';
import { ReactComponent as ZENDESK } from '@svg/zendesk.svg';
import { ReactComponent as KAFKA } from '@svg/kafka.svg';
import { ReactComponent as AZURE_EVENT_HUB } from '@svg/azure_event_hub.svg';
import { ReactComponent as ITERABLE } from '@svg/iterable.svg';
import { ReactComponent as FIREHOSE } from '@svg/firehose.svg';
import { ReactComponent as EVENTBRIDGE } from '@svg/eventbridge.svg';
import { ReactComponent as DIGITAL_OCEAN_SPACES } from '@svg/digital_ocean_spaces.svg';
import { ReactComponent as INDICATIVE } from '@svg/indicative.svg';
import { ReactComponent as OPTIMIZELY } from '@svg/optimizely.svg';
import { ReactComponent as OPTIMIZELY_FULLSTACK } from '@svg/optimizely_fullstack.svg';
import { ReactComponent as PENDO } from '@svg/pendo.svg';
import { ReactComponent as GOOGLEPUBSUB } from '@svg/googlepubsub.svg';
import { ReactComponent as MONETATE } from '@svg/monetate.svg';
import { ReactComponent as TVSQUARED } from '@svg/tvsquared.svg';
import { ReactComponent as LYTICS } from '@svg/lytics.svg';
import { ReactComponent as DRIFT } from '@svg/drift.svg';
import { ReactComponent as MARKETO } from '@svg/marketo.svg';
import { ReactComponent as PARDOT } from '@svg/salesforce.svg';
import { ReactComponent as PINTEREST_TAG } from '@svg/pinterest_tag.svg';
import { ReactComponent as TWITTER } from '@svg/twitter.svg';
import { ReactComponent as TAPLYTICS } from '@svg/taplytics.svg';
import { ReactComponent as ADOBE_ANALYTICS } from '@svg/adobe_analytics.svg';
import { ReactComponent as REDIS } from '@svg/redis.svg';
import { ReactComponent as MOENGAGE } from '@svg/moengage.svg';
import { ReactComponent as SPLITIO } from '@svg/splitio.svg';
import { ReactComponent as POSTHOG } from '@svg/posthog.svg';
import { ReactComponent as USERLIST } from '@svg/userlist.svg';
import { ReactComponent as BIGQUERY } from '@svg/bq.svg';
import { ReactComponent as CONFLUENT_CLOUD } from '@svg/confluentcloud.svg';
import { ReactComponent as APPCENTER } from '@svg/appcenter.svg';
import { ReactComponent as ALGOLIA } from '@svg/algolia.svg';
import { ReactComponent as AWIN } from '@svg/awin.svg';
import { ReactComponent as BINGADS } from '@svg/bingads.svg';
import { ReactComponent as CRITEO } from '@svg/criteo.svg';
import { ReactComponent as DELIGHTED } from '@svg/delighted.svg';
import { ReactComponent as DRIP } from '@svg/drip.svg';
import { ReactComponent as FB_CUSTOM_AUDIENCE } from '@svg/facebook_ads.svg';
import { ReactComponent as GAINSIGHT } from '@svg/gainsight_cs.svg';
import { ReactComponent as GAINSIGHT_PX } from '@svg/gainsight_px.svg';
import { ReactComponent as LINKEDIN_INSIGHT_TAG } from '@svg/linkedin_ads.svg';
import { ReactComponent as MARKETO_BULK_UPLOAD } from '@svg/marketo.svg';
import { ReactComponent as MSSQL } from '@svg/mssql.svg';
import { ReactComponent as OMETRIA } from '@svg/ometria.svg';
import { ReactComponent as PIPEDRIVE } from '@svg/pipedrive.svg';
import { ReactComponent as PROFITWELL } from '@svg/profitwell.svg';
import { ReactComponent as QUALTRICS } from '@svg/qualtrics.svg';
import { ReactComponent as QUANTUMMETRIC } from '@svg/quantummetric.svg';
import { ReactComponent as RECURLY } from '@svg/recurly.svg';
import { ReactComponent as REDDIT_PIXEL } from '@svg/reddit_pixel.svg';
import { ReactComponent as S3_DATALAKE } from '@svg/s3_datalake.svg';
import { ReactComponent as SENDGRID } from '@svg/sendgrid.svg';
import { ReactComponent as SENTRY } from '@svg/sentry.svg';
import { ReactComponent as SNAP_PIXEL } from '@svg/snap_pixel.svg';
import { ReactComponent as TRENGO } from '@svg/trengo.svg';

import theme from '@css/theme';

const DestinationIcon = (props: any) => {
  // Making medium size default.
  let height = props.height || theme.iconSize.medium;
  let width = props.width || theme.iconSize.medium;

  switch (props.destination.toLowerCase()) {
    case 'am':
      return <AM width={width} height={height} />;
    case 'appcues':
      return <APPCUES width={width} height={height} />;
    case 'algolia':
      return <ALGOLIA width={width} height={height} />;
    case 'awin':
      return <AWIN width={width} height={height} />;
    case 'bingads':
      return <BINGADS width={width} height={height} />;
    case 'criteo':
      return <CRITEO width={width} height={height} />;
    case 'clevertap':
      return <CLEVERTAP width={width} height={height} />;
    case 'delighted':
      return <DELIGHTED width={width} height={height} />;
    case 'drip':
      return <DRIP width={width} height={height} />;
    case 'fb_custom_audience':
      return <FB_CUSTOM_AUDIENCE width={width} height={height} />;
    case 'linkedin_insight_tag':
      return <LINKEDIN_INSIGHT_TAG width={width} height={height} />;
    case 'marketo_bulk_upload':
      return <MARKETO_BULK_UPLOAD width={width} height={height} />;
    case 'mssql':
      return <MSSQL width={width} height={height} />;
    case 'ometria':
      return <OMETRIA width={width} height={height} />;
    case 'pipedrive':
      return <PIPEDRIVE width={width} height={height} />;
    case 'profitwell':
      return <PROFITWELL width={width} height={height} />;
    case 'qualtrics':
      return <QUALTRICS width={width} height={height} />;
    case 'quantummetric':
      return <QUANTUMMETRIC width={width} height={height} />;
    case 'recurly':
      return <RECURLY width={width} height={height} />;
    case 'reddit_pixel':
      return <REDDIT_PIXEL width={width} height={height} />;
    case 's3_datalake':
      return <S3_DATALAKE width={width} height={height} />;
    case 'sendgrid':
      return <SENDGRID width={width} height={height} />;
    case 'sentry':
      return <SENTRY width={width} height={height} />;
    case 'snap_pixel':
      return <SNAP_PIXEL width={width} height={height} />;
    case 'trengo':
      return <TRENGO width={width} height={height} />;
    case 'gainsight':
      return <GAINSIGHT width={width} height={height} />;
    case 'gainsight_px':
      return <GAINSIGHT_PX width={width} height={height} />;
    case 'ga':
      return <GA width={width} height={height} />;
    case 'mp':
      return <MP width={width} height={height} />;
    case 'fb':
      return <FB width={width} height={height} />;
    case 'facebook_pixel':
      return <FACEBOOK_PIXEL width={width} height={height} />;
    case 'adj':
      return <ADJ width={width} height={height} />;
    case 'hs':
      return <HS width={width} height={height} />;
    case 's3':
      return <S3 width={width} height={height} />;
    case 'gcs':
      return <GCS width={width} height={height} />;
    case 'minio':
      return <MINIO width={width} height={height} />;
    case 'rs':
      return <RS width={width} height={height} />;
    case 'bq':
      return <BQ width={width} height={height} />;
    case 'snowflake':
      return <SNOWFLAKE width={width} height={height} />;
    case 'postgres':
      return <POSTGRES width={width} height={height} />;
    case 'clickhouse':
      return <CLICKHOUSE width={width} height={height} />;
    case 'af':
      return <AF height={height} />;
    case 'mailchimp':
      return <MAILCHIMP width={width} height={height} />;
    case 'hotjar':
      return <HOTJAR width={width} height={height} />;
    case 'ga4':
      return <GA4 width={width} height={height} />;
    case 'googlesheets':
      return <GOOGLESHEETS width={width} height={height} />;
    case 'salesforce':
      return <SALESFORCE width={width} height={height} />;
    case 'hubspot':
      return <HUBSPOT width={width} height={height} />;
    case 'segment':
      return <SEGMENT width={width} height={height} />;
    case 'autopilot':
      return <AUTOPILOT width={width} height={height} />;
    case 'googleads':
      return <GOOGLEADS width={width} height={height} />;
    case 'azure_blob':
      return <AZURE_BLOB width={width} height={height} />;
    case 'vwo':
      return <VWO width={width} height={height} />;
    case 'intercom':
      return <INTERCOM width={width} height={height} />;
    case 'heap':
      return <HEAP width={width} height={height} />;
    case 'branch':
      return <BRANCH width={width} height={height} />;
    case 'gtm':
      return <GTM width={width} height={height} />;
    case 'braze':
      return <BRAZE width={width} height={height} />;
    case 'keen':
      return <KEEN width={width} height={height} />;
    case 'kochava':
      return <KOCHAVA width={width} height={height} />;
    case 'kissmetrics':
      return <KISSMETRICS width={width} height={height} />;
    case 'klaviyo':
      return <KLAVIYO width={width} height={height} />;
    case 'customerio':
      return <CUSTOMERIO width={width} height={height} />;
    case 'chartbeat':
      return <CHARTBEAT width={width} height={height} />;
    case 'fullstory':
      return <FULLSTORY width={width} height={height} />;
    case 'firebase':
      return <FIREBASE width={width} height={height} />;
    case 'leanplum':
      return <LEANPLUM width={width} height={height} />;
    case 'webhook':
      return <WEBHOOK width={width} height={height} />;
    case 'personalize':
      return <PERSONALIZE width={width} height={height} />;
    case 'lotame_mobile':
      return <LOTAME_MOBILE width={width} height={height} />;
    case 'lotame':
      return <LOTAME width={width} height={height} />;
    case 'slack':
      return <SLACK width={width} height={height} />;
    case 'sfmc':
      return <SALESFORCE width={width} height={height} />;
    case 'bugsnag':
      return <BUGSNAG width={width} height={height} />;
    case 'kinesis':
      return <KINESIS width={width} height={height} />;
    case 'kustomer':
      return <KUSTOMER width={width} height={height} />;
    case 'zendesk':
      return <ZENDESK width={width} height={height} />;
    case 'kafka':
      return <KAFKA width={width} height={height} />;
    case 'azure_event_hub':
      return <AZURE_EVENT_HUB width={width} height={height} />;
    case 'iterable':
      return <ITERABLE width={width} height={height} />;
    case 'firehose':
      return <FIREHOSE width={width} height={height} />;
    case 'eventbridge':
      return <EVENTBRIDGE width={width} height={height} />;
    case 'digital_ocean_spaces':
      return <DIGITAL_OCEAN_SPACES width={width} height={height} />;
    case 'indicative':
      return <INDICATIVE width={width} height={height} />;
    case 'optimizely':
    case 'optimizely_fullstack':
      return <OPTIMIZELY width={width} height={height} />;
    case 'googlepubsub':
      return <GOOGLEPUBSUB width={width} height={height} />;
    case 'monetate':
      return <MONETATE width={width} height={height} />;
    case 'tvsquared':
      return <TVSQUARED width={width} height={height} />;
    case 'drift':
      return <DRIFT width={width} height={height} />;
    case 'marketo':
      return <MARKETO width={width} height={height} />;
    case 'pardot':
      return <PARDOT width={width} height={height} />;
    case 'pinterest_tag':
      return <PINTEREST_TAG width={width} height={height} />;
    case 'pendo':
      return <PENDO width={width} height={height} />
    case 'twitter_ads':
      return <TWITTER width={width} height={height} />;
    case 'taplytics':
      return <TAPLYTICS width={width} height={height} />;
    case 'adobe_analytics':
      return <ADOBE_ANALYTICS width={width} height={height} />;
    case 'lytics':
      return <LYTICS width={width} height={height} />;
    case 'redis':
      return <REDIS width={width} height={height} />;
    case 'moengage':
      return <MOENGAGE width={width} height={height} />;
    case 'posthog':
      return <POSTHOG width={width} height={height} />;
    case 'splitio':
      return <SPLITIO width={width} height={height} />;
    case 'userlist':
      return <USERLIST width={width} height={height} />;
    case 'bigquery':
      return <BIGQUERY width={width} height={height} />;
    case 'confluent_cloud':
      return <CONFLUENT_CLOUD width={width} height={height} />;
    case 'appcenter':
      return <APPCENTER width={width} height={height} />;
    case 'active_campaign':
      return <ACTIVE_CAMPAIGN width={width} height={height} />;
    default:
      break;
  }
  return <div />;
};

export default DestinationIcon;
